import BasedHeader from "../components/BasedHeader";
import { useEffect, useState } from "react";
import { sdk } from "../lib/thirdweb";
import { FaTwitter, FaDiscord, FaPalette } from "react-icons/fa";
import { FaTelegramPlane } from "react-icons/fa";
import { SiArtstation } from "react-icons/si";

interface Holder {
  address: string;
  count: number;
}

export default function Community() {
  const [leaderboard, setLeaderboard] = useState<Holder[]>([]);
  const [loading, setLoading] = useState(true);
  const contractAddress = "0xfb70faa694ce1f7c6ab9fdd037d80d20a7107423";

  useEffect(() => {
    const fetchLeaderboard = async () => {
      try {
        const nftCollection = await sdk.getContract(contractAddress, "nft-collection");
        const allOwners = await nftCollection.erc721.getAllOwners();

        const holderCounts: Record<string, number> = {};
        allOwners.forEach((entry) => {
          if (typeof entry.owner === "string") {
            holderCounts[entry.owner] = (holderCounts[entry.owner] || 0) + 1;
          }
        });

        const sortedHolders = Object.entries(holderCounts)
          .map(([address, count]) => ({ address, count }))
          .sort((a, b) => b.count - a.count)
          .slice(0, 100);

        setLeaderboard(sortedHolders);
      } catch (error) {
        console.error("Error fetching leaderboard:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchLeaderboard();
  }, []);

  return (
    <>
      <BasedHeader />
      <div className="min-h-screen bg-gradient-radial from-gray-900 via-black to-black text-white pt-28 relative flex flex-col items-center">
        <div className="container mx-auto max-w-3xl px-4 py-20 relative">
          {/* Ponks Leaderboard Heading */}
          <div className="relative mb-6 p-6 rounded-xl border-4 border-purple-500 overflow-hidden text-center">
            <h1 className="text-5xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-purple-600">
              🏆 Ponks Leaderboard
            </h1>
          </div>

          {/* Social Links Now Positioned Below the Heading */}
          <div className="flex justify-center space-x-8 mb-12 mt-4">
            <a
              href="https://x.com/DanMason1319083"
              target="_blank"
              rel="noopener noreferrer"
              className="flex flex-col items-center text-blue-400 hover:text-blue-500 transition transform hover:scale-110 hover:shadow-lg"
            >
              <FaPalette className="text-3xl mb-1" />
              <span className="text-sm">Artist D</span>
            </a>

            <a
              href="https://x.com/PPBoatTavern"
              target="_blank"
              rel="noopener noreferrer"
              className="flex flex-col items-center text-blue-400 hover:text-blue-500 transition transform hover:scale-110 hover:shadow-lg"
            >
              <FaTwitter className="text-3xl mb-1" />
              <span className="text-sm">Team Hairylabs</span>
            </a>

            <a
              href="https://danielmason6.artstation.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="flex flex-col items-center text-blue-300 hover:text-blue-400 transition transform hover:scale-110 hover:shadow-lg"
            >
              <SiArtstation className="text-3xl mb-1" />
              <span className="text-sm"> D Artstation</span>
            </a>

            <a
              href="https://t.me/basedponks"
              target="_blank"
              rel="noopener noreferrer"
              className="flex flex-col items-center text-blue-500 hover:text-blue-600 transition transform hover:scale-110 hover:shadow-lg"
            >
              <FaTelegramPlane className="text-3xl mb-1" />
              <span className="text-sm">Telegram</span>
            </a>

            <a
              href="https://discord.gg/4bGBR56wy5"
              target="_blank"
              rel="noopener noreferrer"
              className="flex flex-col items-center text-indigo-400 hover:text-indigo-500 transition transform hover:scale-110 hover:shadow-lg"
            >
              <FaDiscord className="text-3xl mb-1" />
              <span className="text-sm"> Discord</span>
            </a>
          </div>

          {loading ? (
            <p className="text-center text-gray-400">⏳ Loading top NFT holders...</p>
          ) : leaderboard.length ? (
            <div className="space-y-1">
              {leaderboard.map((user, index) => (
                <div
                  key={index}
                  className="flex justify-between items-center p-3 glass rounded-xl hover:bg-white/5 transition transform hover:scale-105"
                >
                  <span className="text-lg">
                    {index + 1}. {index === 0 ? "🐋 " : ""}
                    {user.address.slice(0, 6)}...{user.address.slice(-4)}
                  </span>
                  <span className="text-lg">💎 {user.count} NFTs</span>
                </div>
              ))}
            </div>
          ) : (
            <p className="text-center text-gray-400">No holders found.</p>
          )}
        </div>
      </div>
    </>
  );
}
